import { useEffect } from 'react';

const SUFFIX = 'KinoKlik';

/**
 * Sets the browser tab title.
 * @param {string} title - Page-specific title. Pass empty/null for just "KinoKlik".
 */
export default function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} - ${SUFFIX}` : SUFFIX;
    return () => { document.title = SUFFIX; };
  }, [title]);
}
